import { render } from "./ViewDistributorStaff.vue?vue&type=template&id=4c651ab6&scoped=true"
import script from "./ViewDistributorStaff.vue?vue&type=script&lang=js"
export * from "./ViewDistributorStaff.vue?vue&type=script&lang=js"

import "./ViewDistributorStaff.vue?vue&type=style&index=0&id=4c651ab6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c651ab6"]])

export default __exports__